import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'
import $ from 'jquery'

const EMULATION_MODE_RANKINGREPORTS = false


/*
 * Ranking Reports Actions
 * 
 */

export function fetchReports(dispatch) {
    let cmd = 'FETCH_REPORTS'

    if (EMULATION_ALL || EMULATION_MODE_RANKINGREPORTS)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('RankingReports'), { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchReportsError(dispatch) {

    dispatch(
        {
            type: 'FETCH_REPORTS_ERROR'
        }
    )
}

export function export_excel_ranking_reports(dispatch, filter, callback) {
    $('#reports *').prop('disabled', true);
    let cmd = 'FETCH_REPORTS';
    let done = true;
    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            });

        var stringify = {};
        stringify.reportName = filter.ReportName;
        if (filter.Location !== "Select") {
            stringify.location = filter.Location;
        }

        dispatch(
            {
                type: 'EXPORT_START_RANKING_REPORTS',
                payload: {
                    data: false
                }
            }
        )

        let percComplete = 0;
        dispatch(
            {
                type: 'PERCENTAGE_COMPLETE_RANKING_REPORTS',
                payload: {
                    data: percComplete
                }
            }
        )

        document.getElementById("startExport").style.display = "inline";

        axios.post(buildRequestUrl('RankingReports/RankingReportsByExport'), JSON.stringify(stringify),
            {
                responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                onDownloadProgress: progressEvent => {

                    dispatch(
                        {
                            type: 'FINISH_EXPORT_RANKING_REPORTS',
                            payload: {
                                data: percComplete
                            }


                        }
                    )

                    dispatch(
                        {
                            type: 'COMPLETE_EXPORT_RANKING_REPORTS',
                            payload: {
                                data: true
                            }


                        }
                    )


                }
            })
            .then((resp) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'RankingReport_Export.xlsx');
                document.body.appendChild(link);
                link.click();
                $('#reports *').prop('disabled', false);
                dispatch(
                    {
                        type: 'COMPLETE_EXPORT_RANKING_REPORTS',
                        payload: {
                            data: false
                        }


                    }
                )

                setTimeout("document.getElementById('startExport').style.display = 'none';", 1000);

            })
            .catch((err) => {
                //TODO:
                alert(err);
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })

}

